export const FONTS_SETTINGS_SIDEBAR = {
  FONT_SEARCH_PLACEHOLDER: {
    key: 'FONT_SEARCH_PLACEHOLDER',
    value: 'Try “Calligraphy” or “Open Sans”',
  },
  GOOGLE_FONTS_BUTTON: { key: 'GOOGLE_FONTS_BUTTON', value: 'Google fonts' },
  UPLOAD_FONTS_BUTTON: { key: 'UPLOAD_FONTS_BUTTON', value: 'Upload Font' },
  CANCEL_LABEL: { key: 'CANCEL_LABEL', value: 'Cancel' },
  CONTINUE_APPLY_FONT_LABEL: { key: 'CONTINUE_APPLY_FONT_LABEL', value: 'Continue Applying font' },
  FONT_APPLY_WARNING_TEXT: { key: 'FONT_APPLY_WARNING_TEXT', value: 'This font does not contain Bold / Italic font files in our system. Any Bold / Italic formatting in the selection might be removed due to this action. Do you want to proceed?' },
};
